import { View } from 'pacto';
import { AccountData } from "../../account/service/AccountData";
import { AccountHelper } from '../../account/service/AccountHelper';
import { PianoHelper } from "../../account/service/PianoHelper";
import { ConsoleDebug } from '../../../_utils/ConsoleDebug';
import Micromodal from 'micromodal';

const ID_CORE_REGISTER_FORM = 'core-register-form';
const ID_NAVIGATION_ACCOUNT = 'navigation-account';
const CLASS_CORE_REGISTER_HIDDEN = 'core-register--hidden';
const CLASS_MODAL_OPEN_CLASS = 'modal--is-open';
const SELECTOR_MODAL = '.modal';
const CTXT_KEY_EVENT_REGISTER_SUCCESS = 'event:account_register_successfully';
const CTXT_KEY_EVENT_STOP_BUTTON_BUSY = 'event:account_stop_button_busy';

export class Register extends View {

  constructor(options) {
    super(options);

    this.logInstance = new ConsoleDebug('debug-account', 'Register');
    this.logInstance.log('core/login/views/Register.js constructor');

    this.registerSubmit = this.registerSubmit.bind(this);
    this.buildError = this.buildError.bind(this);
    this.accountData = new AccountData(this.context);
    this.pianoHelper = new PianoHelper(this.context);

    const accountEl = document.querySelector('#' + ID_NAVIGATION_ACCOUNT);
    if ( accountEl !== null ) {
      options.el = accountEl;
      this.accountHelper = new AccountHelper(options, this);
    }

    // Exception for Studi+ - Hide Modal and reload page after successful registration
    if (window.location.pathname.includes("/angebote/studiabo")) {
      this.logInstance.log("Studi-Plus: Hide Modal after successful registration");
      this.context.on(CTXT_KEY_EVENT_REGISTER_SUCCESS, (event) => {
        this.logInstance.log('Auf Event \'' + CTXT_KEY_EVENT_REGISTER_SUCCESS + '\' reagiert, this.hideRegisterModal() aufrufen', event)
        this.hideRegisterModal.call(this);
      });
    }
  }

  render() {
    this.logInstance.log('render()');

    this.el.querySelector('form')?.addEventListener('submit', this.registerSubmit);

    // handle the explicit 'loginRequired' Piano callback
    window.tp = window.tp || [];
    window.tp.push(["addHandler", "loginRequired", this.pianoHandlerLoginRequired.bind(this)]);

    return this;
  }

  registerSubmit(event) {
    this.logInstance.log("registerSubmit() called");

    event.preventDefault(); // Standard Formular Submit-Handler unterbrechen
    const formNode = event.target;

    // Bussy Button aktivieren
    this.accountHelper.startButtonBusyLoop(formNode);

    let fetchInput, fetchInit, autologin;

    // Ziel-URL / API-Endpoint für Login Zugangsdaten
    if (formNode.getAttribute('data-endpoint') === null) {
      this.buildError();
      return;
    }

    autologin = formNode.getAttribute('data-autologin');
    fetchInput = formNode.getAttribute('data-endpoint');
    fetchInput += `?rand=${Math.random()}`;
    const formData = new FormData(formNode);

    if (typeof window.nfyPu === 'number') {
      formData.append('puid', window.nfyPu);
    }
    if (autologin !== null) {
      formData.append('autologin', autologin);
    }

    fetchInit = { method: 'POST', body: formData, credentials: 'include' };

    // Wenn Fractal Web UI Server, dann via GET
    if (window.location.host.match(/^localhost/) !== null) {
      fetchInit = {};
      if (formData.get('login') !== null) {
        fetchInput += `&login=${formData.get('login')}`;
      }
      if (formData.get('pass') !== null) {
        fetchInput += `&pass=${formData.get('pass')}`;
      }
      if (formData.get('salutation') !== null) {
        fetchInput += `&salutation=${formData.get('salutation')}`;
      }
      if (formData.get('firstname') !== null) {
        fetchInput += `&firstname=${formData.get('firstname')}`;
      }
      if (formData.get('lastname') !== null) {
        fetchInput += `&lastname=${formData.get('lastname')}`;
      }
      if (autologin !== null) {
        fetchInput += `&autologin=${autologin}`;
      }
    }

    window.fetch(fetchInput, fetchInit)
      .then((response) => response.json())
      .then((data) => {
        // success, registerError, isLoggedIn, loginCookies, loginError, loginErrorHelpLink
        if (typeof data.success === 'boolean' && data.success ) {
          this.context.trigger(CTXT_KEY_EVENT_REGISTER_SUCCESS);
          this.context.trigger(CTXT_KEY_EVENT_STOP_BUTTON_BUSY);

          // Pop-Up Registrierung
          if ( formNode.id === ID_CORE_REGISTER_FORM ) {
            const titleNode = this.el.querySelector('#core-register-title');
            if (titleNode != null) {
              titleNode.innerHTML = 'Vielen Dank für Ihre Registrierung!'
            }
            // Falls Autologin aktiviert, dann passenden Text der Bestätigungsseite anzeigen
            if (autologin && data.isLoggedIn) {
              this.accountHelper.login(data, formNode);
              this.el.querySelector('#core-register-step2-autologin-success')?.classList.remove(CLASS_CORE_REGISTER_HIDDEN);
            } else {
              this.el.querySelector('#core-register-step2-autologin-fail')?.classList.remove(CLASS_CORE_REGISTER_HIDDEN);
            }
            // Registrierung Bestätigungsseite anzeigen
            this.el.querySelector('#core-register-step1')?.classList.add(CLASS_CORE_REGISTER_HIDDEN);
            this.el.querySelector('#core-register-step2')?.classList.remove(CLASS_CORE_REGISTER_HIDDEN);
          }

          // Nach erfolgreicher Registrierung die Formularfelder zurücksetzen
          this.accountHelper.resetForm(formNode);
        } else {
          this.buildError(data.registerError);
        }
      })
      .catch((error) => {
        this.logInstance.log('Error:', error);
        this.buildError();
        this.context.trigger(CTXT_KEY_EVENT_STOP_BUTTON_BUSY);
      });
  }

  /**
   * handle the explicit 'loginRequired' Piano callback
   *
   * @param pianoCheckoutParams The value named params in this example contains data required for continuing the checkout flow
   * after user authentication. It could be stored as a local variable during runtime if the user never leaves
   * the page during authentication. If the user has to be redirected to another page for authentication,
   * then the step in the checkout, i.e. the params object, could be stored as a cookie.
   * https://docs.piano.io/piano-id-auth-sync/?paragraphId=0a98b93b4c30ea1
   */
  async pianoHandlerLoginRequired(pianoCheckoutParams) {
    this.logInstance.log('Piano callback \'loginRequired\' triggered, arg params', pianoCheckoutParams);

    if ( typeof pianoCheckoutParams !== "undefined" ) {

      // Sets the cookie with the current state of the user
      this.pianoHelper.savePianoParams(pianoCheckoutParams);

      // When logged in, call startCheckout directly with pianoParams
      if ( await this.accountData.isLoggedIn() ) {
        this.pianoHelper.startCheckout(pianoCheckoutParams);
      }
    }
    else
    {
      this.logInstance.log('pianoCheckoutParams is undefined, don\'t call savePianoParams() and startCheckout()');
    }

    // If not logged in, then show the register form
    if ( !await this.accountData.isLoggedIn() ) {

      this.showRegisterModal.call(this);

      // when event registration successful triggered hide modal
      this.context.on(CTXT_KEY_EVENT_REGISTER_SUCCESS, (event) => {
        this.logInstance.log('Auf Event \'' + CTXT_KEY_EVENT_REGISTER_SUCCESS + '\' reagiert, this.hideRegisterModal() aufrufen', event)
        this.hideRegisterModal.call(this);
      });
    }

    // this will prevent the Piano error screen from displaying
    return false;
  }

  /**
   * show modal "core-register" with register form
   */
  showRegisterModal () {
    this.logInstance.log('showRegisterModal() called');

    const goalgradientEl = this.el.querySelector('.goalgradient');
    goalgradientEl.style.display = "block";

    // Muss verwendet werden, da das Registrierungsformular außerhalb der Paywall keinen Goal-Gradient zeigen darf
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if(!mutation.target.classList.contains('modal--is-open')) {
            goalgradientEl.style.display = "none";
          }
        }
      }
    });

    const config = { attributes: true };
    const modalEl = this.el.querySelector('.modal');
    observer.observe(modalEl, config);

    const registerModalIntro = this.el.querySelector('.core-register__intro');

    if (registerModalIntro){
      this.logInstance.log('Hide core-register Intro-Text');
      registerModalIntro.style.display = 'none';
    }

    const modalId = this.el.querySelector(SELECTOR_MODAL)?.getAttribute('id');
    if ( modalId !== null ) {
      this.logInstance.log('Show modal #' + modalId);
      Micromodal.show(modalId, { openClass: CLASS_MODAL_OPEN_CLASS});
    } else {
      this.logInstance.warn('No modal found with selector \'' + SELECTOR_MODAL + '\'.' +
        'Actually, the login form is rendered on every page, this case must not occur.');
    }
  }

  hideRegisterModal () {
    this.logInstance.log('hideRegisterModal() called');

    const modalId = this.el.querySelector(SELECTOR_MODAL)?.getAttribute('id');
    if ( modalId !== null ) {
      this.logInstance.log('Hide modal #' + modalId);
      Micromodal.close(modalId, { openClass: CLASS_MODAL_OPEN_CLASS});
    } else {
      this.logInstance.warn('No modal found with selector \'' + SELECTOR_MODAL + '\'.' +
        'Actually, the login form is rendered on every page, this case must not occur.');
    }
  }

  buildError(explictMessage) {
    this.logInstance.log('buildError()');
    this.context.trigger(CTXT_KEY_EVENT_STOP_BUTTON_BUSY);

    let message = 'Es ist ein technisches Problem aufgetreten. Bitte versuchen Sie es später noch einmal. Der Webmaster wurde informiert.';
    if (explictMessage !== undefined && explictMessage !== '') {
      message = explictMessage;
    }
    const el = this.el.querySelector('[class*="__error"]'); // matched to .core-register__error
    if ( el !== null ) {
      // Fehlermeldung schreiben
      el.textContent = message;
      el.classList.remove(CLASS_CORE_REGISTER_HIDDEN);
    } else {
      this.logInstance.log('Keine Error-Container gefunden für Fehlermeldung => ' + message);
    }
  }
}
